import { useState } from 'react';
import { CommentAPI, Nullable, scrollToNewElement } from '@shared';
import { useMutation, useQuery } from '@tanstack/react-query';
import { auditApi } from 'App';
import { UseMutateFunction } from '@tanstack/react-query/src/types';

export type useCommentsReturnType = [
  Nullable<CommentAPI[]>,
  UseMutateFunction<CommentAPI, unknown, string>,
  boolean
];

export const useComments = (session: string): useCommentsReturnType => {
  const { mutate: addComment, isLoading: isCommentsUpdating } = useMutation({
    mutationFn: (comment: string) => auditApi.addComment(session, comment),
    onSuccess: (data) => {
      setComments((prevState) => [...prevState, data]);
      scrollToNewElement('comment');
    },
  });

  const { isLoading: isCommentsLoading } = useQuery(
    ['comments', session],
    () => auditApi.getComments(session),
    {
      onSuccess: (data) => setComments(data),
      staleTime: undefined,
    }
  );

  const isLoading = isCommentsLoading && isCommentsUpdating;

  const [comments, setComments] = useState<CommentAPI[]>([]);

  return [comments, addComment, isLoading];
};
